module.exports = __webpack_public_path__ + "static/media/as.83064c6f.svg";